import React, { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery';

import Model, { onChange as onChangeModel } from '../../lib/Model'

import { H2, Form, Field, Input, Note, Button } from '../Common'

import style from './Form.scss'

class FormForgotPassword extends Component {
  static propTypes = {
    search: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
  }

  state = {
    error: false,
    form: {
      submitted: false,
      loading: false,
      email: new Model('email', this.props.search.email, 'email'),
    },
  }

  componentDidMount() {
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.render($('#g-recaptcha-forgot')[0])
    }
  }

  onChange = (event, model) => {
    this.setState(onChangeModel(model))
  }

  handleSubmit = () => {
    const { submitted, email } = this.state.form
    if (submitted === false) {
      this.setState((state) => ({
        ...state,
        form: {
          ...state.form,
          submitted: true,
        },
      }))
    }

    if (this.props.loading || email.invalid) {
      return
    }

    if ($('textarea.g-recaptcha-response')[0] == null || $('textarea.g-recaptcha-response')[0].value == '') {
      this.setState((state) => ({
        ...state,
        form: {
          ...state.form,
          submitted: true,
          reqcaptcha: true,
        },
      }))
      return
    }
    const recaptchaResponse = $('textarea.g-recaptcha-response')[0].value;

    this.props.onSubmit(
      {
        email: email.value,
        recaptchaResponse: recaptchaResponse
      },
      (err) => {
        if (!err) return
        const invalid_captcha = err && err.response && err.response.data && err.response.data.status == 'invalid_captcha'
        const error = !invalid_captcha
        grecaptcha.reset();
        this.setState((state) => ({
          ...state,
          error: error,
          form: {
            ...state.form,
            invalid_captcha: invalid_captcha,
          },
        }))
      },
    )
  }

  render() {
    const { loading, recaptchakey } = this.props
    const { error, form } = this.state
    const { submitted, email, reqcaptcha, invalid_captcha } = form
    const emailInvalid = submitted && email.untouched && email.invalid

    return (
      <div className={style.wrapper}>
        <H2 className={style.h2}>recuperar senha</H2>
        <Form id="form-esqueci-senha" onSubmit={this.handleSubmit} className={style.form}>
          <Field label="e-mail" className={style.field}>
            <Input
              id="email"
              model={email}
              invalid={emailInvalid}
              onChange={this.onChange}
              size="xl"
              required
              tabIndex={0}
              autoFocus
            />
            <Note id="email-obrigatorio" error show={emailInvalid}>
              campo obrigatório
            </Note>
            <Note id="msg-link-recuperacao">um link de recuperação será enviado para seu e-mail</Note>
          </Field>
          <div data-sitekey={recaptchakey} className="g-recaptcha" id="g-recaptcha-forgot"></div>
          <Button id="submit-enviar" submit loading={loading} theme="greenDecide" xl>
            enviar
          </Button>
          <Note id="ocorreu-problema" error show={error && !loading}>
            ops! ocorreu um problema.
            <br />
            Por favor tente novamente em alguns minutos.
          </Note>
          <Note id="erro-captcha" error show={submitted && reqcaptcha}>
            Por favor, confirme que você não é um robô.
          </Note>
          <Note id="erro-captcha" error show={submitted && invalid_captcha}>
            Houve algum problema na validação do reCAPTCHAT, tente novamente.
          </Note>
        </Form>
      </div>
    )
  }
}

export default FormForgotPassword



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/Form.js